(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsc-dealer-locator-google-"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mapLoader = null;

    function normalize(value) {
      return String(value || '').trim();
    }

    function normalizeSearch(value) {
      return normalize(value).toLowerCase();
    }

    function escapeHtml(value) {
      return normalize(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function dealerAddress(dealer) {
      var line1 = normalize(dealer.address1);
      var line2 = normalize(dealer.address2);
      var city = normalize(dealer.city);
      var state = normalize(dealer.state);
      var postalCode = normalize(dealer.postalCode);
      var country = normalize(dealer.country);
      var cityState = [city, state].filter(Boolean).join(', ');
      var cityLine = [cityState, postalCode].filter(Boolean).join(' ');
      return [line1, line2, cityLine, country].filter(Boolean);
    }

    function dealerSearchText(dealer) {
      return [
        dealer.name,
        dealer.address1,
        dealer.address2,
        dealer.city,
        dealer.state,
        dealer.postalCode,
        dealer.country,
        dealer.phone,
        dealer.email,
        dealer.notes
      ].map(normalizeSearch).join(' ');
    }

    function loadGoogleMaps(apiKey) {
      if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
      if (mapLoader) return mapLoader;

      mapLoader = new Promise(function (resolve, reject) {
        var callbackName = 'gscDealerLocatorGoogleMapsReady';
        window[callbackName] = function () {
          resolve(window.google.maps);
          delete window[callbackName];
        };

        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&callback=' + callbackName;
        script.async = true;
        script.defer = true;
        script.onerror = function () {
          reject(new Error('Google Maps failed to load'));
          delete window[callbackName];
        };
        document.head.appendChild(script);
      });

      return mapLoader;
    }

    function initDealerLocator(root) {
      var dataEl = root.querySelector('[data-dealer-data]');
      var listEl = root.querySelector('[data-dealer-list]');
      var searchEl = root.querySelector('[data-dealer-search]');
      var stateEl = root.querySelector('[data-dealer-state]');
      var resetEl = root.querySelector('[data-dealer-reset]');
      var countEl = root.querySelector('[data-dealer-count]');
      var emptyEl = root.querySelector('[data-dealer-empty]');
      var mapEl = root.querySelector('[data-dealer-map]');
      var mapMessageEl = root.querySelector('[data-dealer-map-message]');
      var apiKey = normalize(root.dataset.googleMapsKey);
      var dealers = [];
      var map = null;
      var infoWindow = null;
      var markers = [];
      var activeIndex = -1;

      if (!dataEl || !listEl || !searchEl || !stateEl || !resetEl || !countEl || !emptyEl || !mapEl || !mapMessageEl) return;

      try {
        dealers = JSON.parse(dataEl.textContent).map(function (dealer, index) {
          dealer.index = index;
          dealer.searchText = dealerSearchText(dealer);
          dealer.lat = parseFloat(dealer.latitude);
          dealer.lng = parseFloat(dealer.longitude);
          dealer.hasLocation = isFinite(dealer.lat) && isFinite(dealer.lng);
          return dealer;
        });
      } catch (error) {
        dealers = [];
      }

      function setMapMessage(message) {
        mapMessageEl.textContent = message;
        mapMessageEl.hidden = !message;
      }

      function populateStates() {
        var states = [];
        dealers.forEach(function (dealer) {
          var state = normalize(dealer.state);
          if (state && states.indexOf(state) === -1) states.push(state);
        });
        states.sort(function (a, b) {
          return a.localeCompare(b);
        });
        states.forEach(function (state) {
          var option = document.createElement('option');
          option.value = state;
          option.textContent = state;
          stateEl.appendChild(option);
        });
      }

      function filteredDealers() {
        var query = normalizeSearch(searchEl.value);
        var state = normalize(stateEl.value);
        return dealers.filter(function (dealer) {
          var matchesQuery = !query || dealer.searchText.indexOf(query) !== -1;
          var matchesState = !state || normalize(dealer.state) === state;
          return matchesQuery && matchesState;
        });
      }

      function dealerHtml(dealer) {
        var address = dealerAddress(dealer).map(escapeHtml).join('<br>');
        var links = [];
        var phone = normalize(dealer.phone);
        var email = normalize(dealer.email);
        var websiteUrl = normalize(dealer.websiteUrl);
        if (phone) links.push('<a href="tel:' + escapeHtml(phone.replace(/[^0-9+]/g, '')) + '">' + escapeHtml(phone) + '</a>');
        if (email) links.push('<a href="mailto:' + escapeHtml(email) + '">' + escapeHtml(email) + '</a>');
        if (websiteUrl) links.push('<a href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener">' + escapeHtml(Theme.translations.dealer_locator_website) + '</a>');

        return [
          '<button class="gsc-dealer-locator__dealer' + (dealer.index === activeIndex ? ' is-active' : '') + '" type="button" data-dealer-index="' + dealer.index + '">',
          '<span class="gsc-dealer-locator__name">' + escapeHtml(dealer.name) + '</span>',
          address ? '<span class="gsc-dealer-locator__address">' + address + '</span>' : '',
          normalize(dealer.notes) ? '<span class="gsc-dealer-locator__notes">' + escapeHtml(dealer.notes) + '</span>' : '',
          '</button>',
          links.length ? '<div class="gsc-dealer-locator__links">' + links.join('') + '</div>' : ''
        ].join('');
      }

      function updateCount(count) {
        var label = count === 1 ? Theme.translations.dealer_locator_count_one : Theme.translations.dealer_locator_count_other;
        countEl.textContent = label.replace('__COUNT__', count);
      }

      function markerTitle(dealer) {
        return normalize(dealer.name);
      }

      function infoWindowContent(dealer) {
        var address = dealerAddress(dealer).map(escapeHtml).join('<br>');
        var websiteUrl = normalize(dealer.websiteUrl);
        return [
          '<div class="gsc-dealer-locator__info-window">',
          '<strong>' + escapeHtml(dealer.name) + '</strong>',
          address ? '<div>' + address + '</div>' : '',
          websiteUrl ? '<a href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener">' + escapeHtml(Theme.translations.dealer_locator_website) + '</a>' : '',
          '</div>'
        ].join('');
      }

      function updateMap(visibleDealers) {
        if (!map || !window.google || !window.google.maps) return;

        markers.forEach(function (marker) {
          marker.setMap(null);
        });
        markers = [];

        var bounds = new window.google.maps.LatLngBounds();
        visibleDealers.forEach(function (dealer) {
          if (!dealer.hasLocation) return;
          var marker = new window.google.maps.Marker({
            position: { lat: dealer.lat, lng: dealer.lng },
            map: map,
            title: markerTitle(dealer)
          });
          marker.dealerIndex = dealer.index;
          marker.addListener('click', function () {
            focusDealer(dealer.index, true);
          });
          markers.push(marker);
          bounds.extend(marker.getPosition());
        });

        if (markers.length > 1) {
          map.fitBounds(bounds, 48);
        } else if (markers.length === 1) {
          map.setCenter(markers[0].getPosition());
          map.setZoom(10);
        }
      }

      function focusDealer(index, fromMarker) {
        var dealer = dealers[index];
        if (!dealer) return;

        activeIndex = index;
        root.querySelectorAll('[data-dealer-index]').forEach(function (button) {
          var isActive = parseInt(button.dataset.dealerIndex, 10) === index;
          button.classList.toggle('is-active', isActive);
          if (isActive && !fromMarker) button.scrollIntoView({ block: 'nearest' });
        });

        if (!map || !dealer.hasLocation || !window.google || !window.google.maps) return;

        var marker = markers.find(function (item) {
          return item.dealerIndex === index;
        });
        if (!marker) return;

        map.panTo(marker.getPosition());
        map.setZoom(Math.max(map.getZoom() || 10, 10));
        infoWindow.setContent(infoWindowContent(dealer));
        infoWindow.open(map, marker);
      }

      function render() {
        var visibleDealers = filteredDealers();
        listEl.innerHTML = visibleDealers.map(function (dealer) {
          return '<li class="gsc-dealer-locator__item">' + dealerHtml(dealer) + '</li>';
        }).join('');
        emptyEl.hidden = visibleDealers.length !== 0;
        updateCount(visibleDealers.length);
        updateMap(visibleDealers);

        if (activeIndex !== -1 && visibleDealers.every(function (dealer) { return dealer.index !== activeIndex; })) {
          activeIndex = -1;
          if (infoWindow) infoWindow.close();
        }
      }

      listEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-dealer-index]');
        if (!button) return;
        focusDealer(parseInt(button.dataset.dealerIndex, 10), false);
      });

      root.querySelector('[data-dealer-controls]').addEventListener('submit', function (event) {
        event.preventDefault();
      });

      searchEl.addEventListener('input', render);
      stateEl.addEventListener('change', render);
      resetEl.addEventListener('click', function () {
        searchEl.value = '';
        stateEl.value = '';
        render();
        searchEl.focus();
      });

      populateStates();
      render();

      if (!dealers.length) {
        setMapMessage(Theme.translations.dealer_locator_no_dealers);
        return;
      }

      if (!apiKey) {
        setMapMessage(Theme.translations.dealer_locator_missing_key);
        return;
      }

      loadGoogleMaps(apiKey)
        .then(function (maps) {
          map = new maps.Map(mapEl, {
            center: { lat: 39.8283, lng: -98.5795 },
            zoom: 4,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true
          });
          infoWindow = new maps.InfoWindow();
          setMapMessage('');
          render();
        })
        .catch(function () {
          setMapMessage(Theme.translations.dealer_locator_map_error);
        });
    }

    document.querySelectorAll('[data-gsc-dealer-locator]').forEach(initDealerLocator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsc-dealer-locator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LEAFLET_VERSION = '1.9.4';
    var LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@' + LEAFLET_VERSION + '/dist/leaflet.css';
    var LEAFLET_CSS_INTEGRITY = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    var LEAFLET_JS_URL = 'https://unpkg.com/leaflet@' + LEAFLET_VERSION + '/dist/leaflet.js';
    var LEAFLET_JS_INTEGRITY = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    var OSM_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
    var OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors';

    var COUNTRY_NAMES = {
      US: 'United States',
      AU: 'Australia',
      AE: 'United Arab Emirates',
      CA: 'Canada',
      GB: 'United Kingdom',
      DE: 'Germany',
      JP: 'Japan',
      NZ: 'New Zealand',
      MX: 'Mexico',
      FR: 'France',
      IT: 'Italy',
      ES: 'Spain',
      NL: 'Netherlands',
      SE: 'Sweden',
      NO: 'Norway',
      DK: 'Denmark',
      FI: 'Finland',
      IE: 'Ireland',
      BE: 'Belgium',
      AT: 'Austria',
      CH: 'Switzerland',
      PT: 'Portugal',
      PL: 'Poland',
      BR: 'Brazil',
      AR: 'Argentina',
      CL: 'Chile',
      ZA: 'South Africa',
      SG: 'Singapore',
      MY: 'Malaysia',
      TH: 'Thailand',
      ID: 'Indonesia',
      PH: 'Philippines',
      KR: 'South Korea',
      TW: 'Taiwan',
      HK: 'Hong Kong',
      IN: 'India',
      SA: 'Saudi Arabia',
      QA: 'Qatar',
      KW: 'Kuwait',
      BH: 'Bahrain',
      OM: 'Oman'
    };

    var leafletLoader = null;

    function normalize(value) {
      return String(value || '').trim();
    }

    function normalizeSearch(value) {
      return normalize(value).toLowerCase();
    }

    function escapeHtml(value) {
      return normalize(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function countryName(code) {
      var key = normalize(code).toUpperCase();
      return COUNTRY_NAMES[key] || key;
    }

    function isUsDealer(dealer) {
      var code = normalize(dealer.country).toUpperCase();
      return !code || code === 'US' || code === 'USA';
    }

    function dealerAddress(dealer) {
      var line1 = normalize(dealer.address1);
      var line2 = normalize(dealer.address2);
      var city = normalize(dealer.city);
      var postalCode = normalize(dealer.postalCode);
      var lines = [line1, line2];

      if (isUsDealer(dealer)) {
        var state = normalize(dealer.state);
        var cityState = [city, state].filter(Boolean).join(', ');
        var cityLine = [cityState, postalCode].filter(Boolean).join(' ');
        lines.push(cityLine);
      } else {
        var province = normalize(dealer.province);
        var cityLine = [city, postalCode].filter(Boolean).join(' ');
        var regionLine = [province, countryName(dealer.country)].filter(Boolean).join(', ');
        lines.push(cityLine);
        lines.push(regionLine);
      }

      return lines.filter(Boolean);
    }

    function dealerSearchText(dealer) {
      return [
        dealer.name,
        dealer.address1,
        dealer.address2,
        dealer.city,
        dealer.state,
        dealer.province,
        dealer.postalCode,
        dealer.country,
        countryName(dealer.country),
        dealer.phone,
        dealer.email,
        dealer.notes
      ].map(normalizeSearch).join(' ');
    }

    function loadLeaflet() {
      if (window.L) return Promise.resolve(window.L);
      if (leafletLoader) return leafletLoader;

      leafletLoader = new Promise(function (resolve, reject) {
        if (!document.querySelector('link[data-leaflet-css]')) {
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = LEAFLET_CSS_URL;
          link.integrity = LEAFLET_CSS_INTEGRITY;
          link.crossOrigin = '';
          link.setAttribute('data-leaflet-css', '');
          document.head.appendChild(link);
        }

        var existing = document.querySelector('script[data-leaflet-js]');
        if (existing) {
          existing.addEventListener('load', function () { resolve(window.L); });
          existing.addEventListener('error', function () { reject(new Error('Leaflet failed to load')); });
          return;
        }

        var script = document.createElement('script');
        script.src = LEAFLET_JS_URL;
        script.integrity = LEAFLET_JS_INTEGRITY;
        script.crossOrigin = '';
        script.async = true;
        script.defer = true;
        script.setAttribute('data-leaflet-js', '');
        script.onload = function () { resolve(window.L); };
        script.onerror = function () { reject(new Error('Leaflet failed to load')); };
        document.head.appendChild(script);
      });

      return leafletLoader;
    }

    function initDealerLocator(root) {
      var dataEl = root.querySelector('[data-dealer-data]');
      var listEl = root.querySelector('[data-dealer-list]');
      var searchEl = root.querySelector('[data-dealer-search]');
      var regionEl = root.querySelector('[data-dealer-region]');
      var resetEl = root.querySelector('[data-dealer-reset]');
      var countEl = root.querySelector('[data-dealer-count]');
      var emptyEl = root.querySelector('[data-dealer-empty]');
      var mapEl = root.querySelector('[data-dealer-map]');
      var mapMessageEl = root.querySelector('[data-dealer-map-message]');
      var dealers = [];
      var map = null;
      var markers = [];
      var activeIndex = -1;

      if (!dataEl || !listEl || !searchEl || !regionEl || !resetEl || !countEl || !emptyEl || !mapEl || !mapMessageEl) return;

      try {
        dealers = JSON.parse(dataEl.textContent).map(function (dealer, index) {
          dealer.index = index;
          dealer.searchText = dealerSearchText(dealer);
          dealer.lat = parseFloat(dealer.latitude);
          dealer.lng = parseFloat(dealer.longitude);
          dealer.hasLocation = isFinite(dealer.lat) && isFinite(dealer.lng);
          return dealer;
        });
      } catch (error) {
        dealers = [];
      }

      function setMapMessage(message) {
        mapMessageEl.textContent = 'All Regions';
        mapMessageEl.hidden = !message;
      }

      function populateRegions() {
        var usStates = [];
        var intlCountries = [];

        dealers.forEach(function (dealer) {
          if (isUsDealer(dealer)) {
            var state = normalize(dealer.state).toUpperCase();
            if (state && usStates.indexOf(state) === -1) usStates.push(state);
          } else {
            var code = normalize(dealer.country).toUpperCase();
            if (code && intlCountries.indexOf(code) === -1) intlCountries.push(code);
          }
        });

        usStates.sort();
        intlCountries.sort(function (a, b) {
          return countryName(a).localeCompare(countryName(b));
        });

        if (usStates.length) {
          var usGroup = document.createElement('optgroup');
          usGroup.label = 'United States';
          usStates.forEach(function (state) {
            var option = document.createElement('option');
            option.value = 'state:' + state;
            option.textContent = state;
            usGroup.appendChild(option);
          });
          regionEl.appendChild(usGroup);
        }

        if (intlCountries.length) {
          var intlGroup = document.createElement('optgroup');
          intlGroup.label = 'International';
          intlCountries.forEach(function (code) {
            var option = document.createElement('option');
            option.value = 'country:' + code;
            option.textContent = countryName(code);
            intlGroup.appendChild(option);
          });
          regionEl.appendChild(intlGroup);
        }
      }

      function filteredDealers() {
        var query = normalizeSearch(searchEl.value);
        var region = normalize(regionEl.value);
        var regionType = '';
        var regionValue = '';
        if (region.indexOf(':') !== -1) {
          var parts = region.split(':');
          regionType = parts[0];
          regionValue = parts[1];
        }

        return dealers.filter(function (dealer) {
          var matchesQuery = !query || dealer.searchText.indexOf(query) !== -1;
          var matchesRegion = true;
          if (regionType === 'state') {
            matchesRegion = isUsDealer(dealer) && normalize(dealer.state).toUpperCase() === regionValue;
          } else if (regionType === 'country') {
            matchesRegion = !isUsDealer(dealer) && normalize(dealer.country).toUpperCase() === regionValue;
          }
          return matchesQuery && matchesRegion;
        });
      }

      function dealerHtml(dealer) {
        var address = dealerAddress(dealer).map(escapeHtml).join('<br>');
        var links = [];
        var phone = normalize(dealer.phone);
        var email = normalize(dealer.email);
        var websiteUrl = normalize(dealer.websiteUrl);
        if (phone) links.push('<a href="tel:' + escapeHtml(phone.replace(/[^0-9+]/g, '')) + '">' + escapeHtml(phone) + '</a>');
        if (email) links.push('<a href="mailto:' + escapeHtml(email) + '">' + escapeHtml(email) + '</a>');
        if (websiteUrl) links.push('<a href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener">' + escapeHtml(Theme.translations.dealer_locator_website) + '</a>');

        return [
          '<button class="gsc-dealer-locator__dealer' + (dealer.index === activeIndex ? ' is-active' : '') + '" type="button" data-dealer-index="' + dealer.index + '">',
          '<span class="gsc-dealer-locator__name">' + escapeHtml(dealer.name) + '</span>',
          address ? '<span class="gsc-dealer-locator__address">' + address + '</span>' : '',
          normalize(dealer.notes) ? '<span class="gsc-dealer-locator__notes">' + escapeHtml(dealer.notes) + '</span>' : '',
          '</button>',
          links.length ? '<div class="gsc-dealer-locator__links">' + links.join('') + '</div>' : ''
        ].join('');
      }

      function updateCount(count) {
        var label = count === 1 ? Theme.translations.dealer_locator_count_one : Theme.translations.dealer_locator_count_other;
        countEl.textContent = label.replace('__COUNT__', count);
      }

      function popupContent(dealer) {
        var address = dealerAddress(dealer).map(escapeHtml).join('<br>');
        var websiteUrl = normalize(dealer.websiteUrl);
        return [
          '<div class="gsc-dealer-locator__info-window">',
          '<strong>' + escapeHtml(dealer.name) + '</strong>',
          address ? '<div>' + address + '</div>' : '',
          websiteUrl ? '<a href="' + escapeHtml(websiteUrl) + '" target="_blank" rel="noopener">' + escapeHtml(Theme.translations.dealer_locator_website) + '</a>' : '',
          '</div>'
        ].join('');
      }

      function updateMap(visibleDealers) {
        if (!map || !window.L) return;

        markers.forEach(function (marker) {
          map.removeLayer(marker);
        });
        markers = [];

        var latLngs = [];
        visibleDealers.forEach(function (dealer) {
          if (!dealer.hasLocation) return;
          var marker = window.L.marker([dealer.lat, dealer.lng], {
            title: normalize(dealer.name)
          });
          marker.bindPopup(popupContent(dealer));
          marker.dealerIndex = dealer.index;
          marker.on('click', function () {
            focusDealer(dealer.index, true);
          });
          marker.addTo(map);
          markers.push(marker);
          latLngs.push([dealer.lat, dealer.lng]);
        });

        if (latLngs.length > 1) {
          map.fitBounds(window.L.latLngBounds(latLngs), { padding: [48, 48] });
        } else if (latLngs.length === 1) {
          map.setView(latLngs[0], 10);
        }
      }

      function focusDealer(index, fromMarker) {
        var dealer = dealers[index];
        if (!dealer) return;

        activeIndex = index;
        root.querySelectorAll('[data-dealer-index]').forEach(function (button) {
          var isActive = parseInt(button.dataset.dealerIndex, 10) === index;
          button.classList.toggle('is-active', isActive);
          if (isActive && !fromMarker) button.scrollIntoView({ block: 'nearest' });
        });

        if (!map || !dealer.hasLocation || !window.L) return;

        var marker = markers.find(function (item) {
          return item.dealerIndex === index;
        });
        if (!marker) return;

        map.panTo(marker.getLatLng());
        if ((map.getZoom() || 0) < 10) map.setZoom(10);
        marker.openPopup();
      }

      function render() {
        var visibleDealers = filteredDealers();
        listEl.innerHTML = visibleDealers.map(function (dealer) {
          return '<li class="gsc-dealer-locator__item">' + dealerHtml(dealer) + '</li>';
        }).join('');
        emptyEl.hidden = visibleDealers.length !== 0;
        updateCount(visibleDealers.length);
        updateMap(visibleDealers);

        if (activeIndex !== -1 && visibleDealers.every(function (dealer) { return dealer.index !== activeIndex; })) {
          activeIndex = -1;
        }
      }

      listEl.addEventListener('click', function (event) {
        var button = event.target.closest('[data-dealer-index]');
        if (!button) return;
        focusDealer(parseInt(button.dataset.dealerIndex, 10), false);
      });

      root.querySelector('[data-dealer-controls]').addEventListener('submit', function (event) {
        event.preventDefault();
      });

      searchEl.addEventListener('input', render);
      regionEl.addEventListener('change', render);
      resetEl.addEventListener('click', function () {
        searchEl.value = '';
        regionEl.value = '';
        render();
        searchEl.focus();
      });

      populateRegions();
      render();

      if (!dealers.length) {
        setMapMessage(Theme.translations.dealer_locator_no_dealers);
        return;
      }

      loadLeaflet()
        .then(function (L) {
          map = L.map(mapEl, {
            zoomControl: true,
            scrollWheelZoom: true
          }).setView([39.8283, -98.5795], 4);

          L.tileLayer(OSM_TILE_URL, {
            maxZoom: 19,
            attribution: OSM_ATTRIBUTION
          }).addTo(map);

          setMapMessage('');
          render();
        })
        .catch(function () {
          setMapMessage(Theme.translations.dealer_locator_map_error);
        });
    }

    document.querySelectorAll('[data-gsc-dealer-locator]').forEach(initDealerLocator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsc-fitment-dropdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.gsc-fitment').forEach(function (root) {
      var dataEl = root.querySelector('[data-fitment-data]');
      if (!dataEl) return;

      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var step1 = root.querySelector('[data-step="1"]');
      var step2 = root.querySelector('[data-step="2"]');
      var cta = root.querySelector('[data-action="go"]');
      if (!step1 || !step2 || !cta) return;

      var step2Placeholder = step2.querySelector('option');
      var placeholderText = step2Placeholder ? step2Placeholder.textContent : '';

      function makePlaceholderOption() {
        var opt = document.createElement('option');
        opt.value = '';
        opt.disabled = true;
        opt.selected = true;
        opt.textContent = placeholderText;
        return opt;
      }

      function resetStep2() {
        step2.replaceChildren(makePlaceholderOption());
        step2.disabled = true;
        cta.disabled = true;
      }

      step1.addEventListener('change', function () {
        var idx = parseInt(step1.value, 10);
        if (isNaN(idx) || !data[idx]) {
          resetStep2();
          return;
        }
        resetStep2();
        var children = data[idx].children || [];
        children.forEach(function (child) {
          var opt = document.createElement('option');
          opt.value = child.url;
          opt.textContent = child.title;
          step2.appendChild(opt);
        });
        step2.disabled = children.length === 0;
      });

      step2.addEventListener('change', function () {
        cta.disabled = !step2.value;
      });

      cta.addEventListener('click', function () {
        if (!step2.value) return;
        window.location.href = step2.value;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
